import { DatasetBase } from '@core/reports-types';

// TODO #86c5d6zvc: replace with an explicit backend-provided unit/aggregation flag.
// Salary metrics aggregate a monetary value, so the tooltip total unit must reflect
// the compensation category (e.g. "EUR per month") instead of the grouped resource.
export const isSalaryMetric = (metric: DatasetBase['metric']): boolean =>
  metric.metric === 'total_salary' || metric.metric === 'average_salary';
